import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../../context/AuthContext";
import { handleGoogleSuccess } from "../../auth/googleAuth"; // adjust path if needed

const AuthModal: React.FC = () => {
  const { login, closeAuthModal } = useAuth();

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* Header */}
        <div style={styles.header}>
          <h2 style={{ margin: 0 }}>Welcome to SocialFlow</h2>
          <button onClick={closeAuthModal} style={styles.closeBtn}>
            ✖
          </button>
        </div>

        <p style={styles.subtitle}>
          Sign in to manage apps, analytics & automation tools.
        </p>

        <div style={{ marginBottom: "12px" }}>
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              if (credentialResponse.credential) {
                login(credentialResponse.credential); // ✅ real JWT
                closeAuthModal(); // ✅ closes properly
              }
            }}
            onError={() => console.log("Google Login Failed")}
          />
        </div>

        {/* Future Providers */}
        <button style={styles.disabledBtn} disabled>
          Continue with Facebook (Coming Soon)
        </button>

        <button style={styles.disabledBtn} disabled>
          Continue with LinkedIn (Coming Soon)
        </button>

        <p style={styles.footerText}>
          By continuing, you agree to our Terms & Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default AuthModal;

/* -------------------------
   STYLES
-------------------------- */

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },

  modal: {
    width: "400px",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 25px 60px rgba(0,0,0,0.2)",
    textAlign: "center",
    animation: "fadeIn 0.25s ease-in-out",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },

  closeBtn: {
    border: "none",
    background: "transparent",
    fontSize: "16px",
    cursor: "pointer",
  },

  subtitle: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "20px",
  },

  googleBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "linear-gradient(90deg, #714B67, #017E84)",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
    marginBottom: "12px",
  },

  disabledBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    background: "#f5f5f5",
    color: "#888",
    marginBottom: "12px",
  },

  footerText: {
    fontSize: "12px",
    color: "#999",
    marginTop: "10px",
  },
};
